import {Settings} from "../http/protocol";
import {userInfo} from "os";


const EXCLUDED_PATHS = [
    "/playnow/resetpassword",
    "/playnow/recover",
    "/playnow/verifyemail",
    "/profile/2fa",
    "/register",
    "/choose-screen-name",
    "/playnow",
    "/casino/exit",
    "/app"
]
const isExcludedPath = (path : string) => {
    let excluded = EXCLUDED_PATHS.some(p => path.startsWith(p));
    return excluded;
}
const getPreviousPath = (paths?: string[], currentPath?: string) => {
    if(!currentPath || !paths || paths.length == 0) {
        return undefined;
    }

    return paths.find( p => p != currentPath && !isExcludedPath(p));
}

export const getPreviousLoggedInPath =  (paths?: string[], currentPath?: string) => {
    let path = getPreviousPath(paths, currentPath);
    if(path) {
        if(path.endsWith("/fun")) {
            path = path.replace("/fun","/real")
        }
        return path;
    }
}
export const getLoggedInRedirect = (settings:Settings, emailVerified:boolean = false, previousPaths? : string[], currentPath?: string) : string => {
    let lastProductUsed = localStorage.getItem("lastProductUsed");

    if(settings.requireUserChannelVerification && !emailVerified) {
        return "/playnow/verifyemail";
    }

    let path = getPreviousLoggedInPath(previousPaths, currentPath);

    if(path) {
        return path;
    }

    if((lastProductUsed === null || lastProductUsed.length === 0) && settings && settings.loginRedirectUrl && settings.loginRedirectUrl.length > 0) {
        if(settings.loginRedirectUrl === "/poker" && settings.pokerEnabled) {
            if(settings.startPokerOnOpen) {
                return "/";
            }
            return "/poker"
        } else if(settings.loginRedirectUrl === "/casino" && settings.casinoEnabled) {
            return "/casino"
        } else if(settings.loginRedirectUrl === "/sportsbook" && settings.sportsbookEnabled) {
            return "/sportsbook"
        } else if(settings.loginRedirectUrl === "/racing" && settings.racingEnabled) {
            return "/racing"
        } else {
            return "/"
        }
    } else {
        if(lastProductUsed === "poker" && settings.pokerEnabled) {
            if(settings.startPokerOnOpen) {
                return "/";
            }
            return "/poker"
        } else if(lastProductUsed === "casino" && settings.casinoEnabled) {
            return "/casino"
        } else if(lastProductUsed === "sportsbook" && settings.sportsbookEnabled) {
            return "/sportsbook"
        } else if(lastProductUsed === "racing" && settings.racingEnabled) {
            return "/racing"
        } else {
            return "/"
        }
    }

}

export default getLoggedInRedirect;